import { z } from "zod";

import { monthlyAuditDate } from "@/schemas";

import {
  environmentalChecklistItem,
  environmentalChecklistItemWithTicket,
} from "../../../../schemas";

export const resEnvChecklistBedroomSchema = z.object({
  auditDate: monthlyAuditDate,
  locationId: z.string().min(1, "Required"),
  reviewerId: z.string().min(1, "Required"),
  bedroomDescription: z.string().min(1, "Required"),
  bedroomBedBug: environmentalChecklistItemWithTicket,
  bedroomHeadBoard: environmentalChecklistItem,
  bedroomBedFrame: environmentalChecklistItem,
  bedroomWall: environmentalChecklistItemWithTicket,
  bedroomCeiling: environmentalChecklistItemWithTicket,
  bedroomWindow: environmentalChecklistItemWithTicket,
  bedroomLight: environmentalChecklistItemWithTicket,
  bedroomCurtain: environmentalChecklistItemWithTicket,
  bedroomCloset: environmentalChecklistItem,
  bedroomClearance: environmentalChecklistItem,
  bedroomClothing: environmentalChecklistItem,
  bedroomBedding: environmentalChecklistItem,
  bedroomFurniture: environmentalChecklistItem,
  bedroomFloor: environmentalChecklistItemWithTicket,
  bedroomHazard: environmentalChecklistItem,
  bedroomGrooming: environmentalChecklistItem,
  bedroomPersonalized: environmentalChecklistItem,
  bedroomDoor: environmentalChecklistItemWithTicket,
  bedroomComment: z.string().optional(),
});
